export default __webpack_public_path__ + "static/media/logo_principal.df6f88aa.png";